module.exports = "<p>\n  approved-drawing works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/approved-drawing/approved-drawing.component.html
// module id = ./src/app/planning/approved-drawing/approved-drawing.component.html
// module chunks = main